import React, { useEffect } from 'react';

const IosDownloadPage = () => {
  useEffect(() => {
    setTimeout(function () {
      window.location = 'https://itunes.apple.com/my/app/flipbizz/id1108359809';
    }, 1000);
  }, []);
  return null;
};
export default IosDownloadPage;
